// @flow
import Add2CartModal from './Add2CartModal';

export default Add2CartModal;
